















import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import MortgageTab from '@/components/modules/App/CalculatorComponent/MortgageTab.vue'
import InstallmentTab from '@/components/modules/App/CalculatorComponent/InstallmentTab.vue'

interface Data {
  selectOption: 'MortgageTab' | 'InstallmentTab'
}

interface Methods {}

interface Computed {}

interface Props {
  sizeFlag: boolean
}

export default Vue.extend({
  name: 'CalculatorComponent',
  components: {
    MortgageTab,
    InstallmentTab
  },
  props: {
    sizeFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectOption: 'MortgageTab'
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
